export class EventHandler {

    public callbacks: Array<() => void> = [];

    /**
     * Register a callback function.
     *
     * @param callback
     * @returns {Function} unregister function
     */
    public register(callback?: () => void) {
        this.callbacks.push(callback);
        return () => {
            this.callbacks = this.callbacks.filter((item) => {
                return (item !== callback);
            });
        };
    }

    /**
     * Trigger all registered callback functions. Arguments provided
     * to trigger are passed to the callbacks.
     */
    public trigger(...args) {
        this.callbacks.forEach((callback) => {
            callback.apply(this, args);
        });
    }

    /**
     * Remove all registered callbacks.
     */
    public destroy() {
        this.callbacks.length = 0;
    }

}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/event.handler/event.handler.ts